import { set } from '@tellus/utils'

/**
 * generate language messages
 * @param {Obje} modules local language modules
 * @param {string} prefix language
 * @returns Object
 */
export function generateMessages(modules, prefix) {
  const messages = {}

  modules.keys().forEach(module => {
    const langModule = modules(module) || {}
    let fileName = module.replace(`./${prefix}/`, '').replace(/^\.\//, '')
    fileName = fileName.substring(0, fileName.lastIndexOf('.'))
    const modulePath = fileName.split('/').join('.')
    if (modulePath) {
      const temp = {}
      Object.keys(langModule).forEach(key => set(temp, key, langModule[key]))
      set(messages, modulePath, temp)
    }
  })

  return messages
}
